export class PaginationInfo {
  pageNumber: number | undefined;
  pageSize?: number = 10;
}

export interface GetSuccessfullPaymentsRequest {
  paginationInfo?: PaginationInfo;
  filter?: Filter;
}

export class Filter {
  customerName: string | undefined;
  customerNationalCode: string | undefined;
  referenceKey: string | undefined;
  paymentDateFrom: Date | undefined;
  paymentDateTo: Date | undefined;
  paymentAmountInRialFrom: number | undefined;
  paymentAmountInRialTo: number | undefined;
}

export interface GetSuccessfullPaymentsResponse {
  customerName: string;
  customerNationalCode: string;
  referenceKey: string;
  paymentAmountRial: number;
  paymentDate: Date;
  paymentDatePersian: string;
  traceNumber: string;
  paymentState: string;
  paymentStateTitle: string;
  gateway: string;
  transactionCode: string;
  organizationTitle: string;
  loanTemplateTitle: string;
}
